var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.12 26.35"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.17,
    cy: 3.08,
    r: 3.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.17,
    cy: 24.5,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.6,
    cy: 6.22,
    r: 2.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 21.36,
    r: 1.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.46,
    cy: 13.79,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.88,
    cy: 13.79,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 6.22,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.6,
    cy: 21.36,
    r: 1.85
  })))));
};
export default SvgSpinner;